import { useState } from "react";
import { useCentralStore } from "../../../store/Central";
import { ConnectRelationshipVendorSelect } from "./cr-select/connect-relationship-vendor-select.component";
import { Button } from "../../../components/ui/button";
import { showNotification } from "@/dentlab/src/store/Central/selectors";

export const ShareConnectRelationshipWithVendor: React.FC = () => {
	const [selectedVendorOrgId, setSelectedVendorOrgId] = useState<
		string | null
	>(null);
	const [message, setMessage] = useState("Guten Tag, gerne möchte ich Sie einladen, auf dentDESK.ch zusammenzuarbeiten.");
	
	const { connectClientToExistingVendorConnectRelationship } = useCentralStore((state) => ({
		connectClientToExistingVendorConnectRelationship: state.connectClientToExistingVendorConnectRelationship,
	}));

  const shareConnectRelationship = async () => {
    if (!selectedVendorOrgId) return;
		const success = await connectClientToExistingVendorConnectRelationship(selectedVendorOrgId, message);
		if (success) {
			showNotification({
				message: "Connect-Beziehung erfolgreich geteilt",
				type: "success",
			});
			window.location.reload();
		}
  };

	return (
		<div>
			<h2 className="text-sm text-gray-500 mb-4">
				Eine bestehende Verbindung zu einem Fremdlabor kann auch
				umgekehrt genutzt werden.
			</h2>

			<ConnectRelationshipVendorSelect
				onSelect={(vendorOrgId) => {
					setSelectedVendorOrgId(vendorOrgId);
				}}
			/>

			<div className="mt-4">
				<span className="text-sm text-gray-700 mb-2 block">
					Nachricht:
				</span>
				<textarea
					value={message}
					onChange={(e) => setMessage(e.target.value)}
					className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
				/>
			</div>
			<div className="mt-4">
				<Button
					onClick={shareConnectRelationship}
					disabled={!selectedVendorOrgId}
					variant={selectedVendorOrgId ? "default" : "secondary"}
					size="sm"
				>
					Verbindung teilen
				</Button>
			</div>
		</div>
	);
};
